import styled from "styled-components";

export const AboutWrapper = styled.div`
display: flex;
flex-direction: column;
padding-top: 100px;
padding-bottom: 100px;
`

export const AboutHeadr = styled.div`
font-size: 36px;
font-weight: 900;
letter-spacing: -0.25px;
color: #091740;
padding: 20px;
margin: auto;
text-align: center;
width: 100%;
`

export const AboutCard = styled.div`
padding: 20px 10px 20px 10px;
display: flex;
flex-direction: column;
text-align: center;
width: 100%;
justify-content: center;
background: #FFFFFF 0% 0% no-repeat padding-box;
border-radius: 10px;
transition: 0.1s linear;
&:hover {
    box-shadow: 32px 32px 48px #050E3514;
  }
`

export const CardHeader = styled.p`
text-align: center;
font-size: 22px;
font-weight: 900;
letter-spacing: -0.15px;
color: #091740;
margin-bottom: 0.68rem;
`
export const CardBody = styled.div`
text-align: center;
font-size: 18px;
font-weight: 400;
letter-spacing: -0.19px;
color: #091740;
`

export const IconWarpper = styled.div`
font-size: 44px;
color: #B4BFCE;
transition: 0.1s linear;
margin-bottom: 20px;
&:hover{
   color: #1D3FC7;
}
`